admin.component('layoutComponent', {
    templateUrl: 'components/layout/layout.html',
    controller: 'layoutComponentController'
});

admin.controller('layoutComponentController', ['$state', 'coreLanguage', 'coreDialog', function($state, $text, $dialog) {
    const $ctrl = this;

    $ctrl.showMenu = () => $state.params.showMenu != false;
    $ctrl.hideNav = () => $state.params.hideNav == true;
    $ctrl.simpleMode = false;
    
    $ctrl.toggleSimpleMode=()=>{
        $ctrl.simpleMode = !$ctrl.simpleMode;
    };

    $ctrl.menuItems = [
        //{
        //    title: $text.menu.dashboard,
        //    route: 'admin.dashboard',
        //    icon: 'ph-gauge'
        //},
        /* {
            title: $text.menu.sales,
            route: 'admin.vendas',
            icon: 'ph-shopping-cart'
        }, */
        {
            title: $text.menu.customers,
            route: 'admin.usuarios',
            icon: 'ph-users-three'
        },
        {
            title: $text.menu.classes,
            route: 'admin.produtos',
            icon: 'ph-factory'
        },
        {
            title: $text.menu.membersArea,
            route: 'admin.areaMembros',
            icon: 'ph-student'
        },
        /* {
            title: $text.menu.faq,
            route: 'admin.editarFaq',
            icon: 'ph-question'
        }, */
        {
            title: $text.menu.notices,
            route: 'admin.avisos',
            icon: 'ph-bell'
        },
        {
            title: "Relatório",
            route: 'admin.relatorios',
            icon: 'ph-newspaper-clipping'
        }
        
    ];

}])